<template>
    <div class="header-container">
        <div class="header">
            <!--            <router-link to="/home"><img src="../../../assets/img/logo_emof.png" alt="" class="logo"/></router-link>-->
            <a :href="`${IMAGE_PATH}`">
                <img alt="" class="logo_zc" :src="user.morgwlogo" v-if="user.morgwlogo"/>
                <img alt="" class="logo" src="../../../assets/img/logo_emof.png" v-else/>
            </a>
            <div class="home flex align-center">
                <div class="service">
                    <i class="iconfont icon-kefu margin-right-xs font-size-lg"></i>客服电话：{{ service_phone }}
                </div>
                <!--                <el-link class="to" :href="web_emof_setting" target="_blank" :underline="false">机构设置</el-link>-->
                <!--                <el-link class="to" :href="web_emof_news" target="_blank" :underline="false">消息中心</el-link>-->

                <div class="header-operate flex flex-direction align-center justify-center" v-if="users>1" @click="toChiose">
                    <i class="icon iconfont icon-jiaohuan"></i>
                    <div class="label">角色选择</div>
                </div>
                <div class="header-operate flex flex-direction align-center justify-center">
                    <div class="flex align-center">
                        <i class="icon iconfont icon-saoyisao_o"></i>
                        <div class="label">扫一扫</div>
                    </div>
                    <div class="label">进入小程序</div>
                    <div class="wx-mini-container flex flex-direction justify-center align-center">
                        <img class="image" src="../../../assets/img/erweima_wx_mini.jpg"/>
                        <div class="tips">扫一扫 进入小程序</div>
                    </div>
                </div>

                <div class="header-operate flex flex-direction align-center justify-center" v-if="user" @click="sginout">
                    <i class="icon iconfont icon-logout"></i>
                    <div class="label">退出登录</div>
                </div>
                <el-link class="header-operate yellow" :href="IMAGE_PATH" :underline="false" target="_blank">
                    <div class="label">访问首页</div>
                </el-link>
<!--                <div class="to margin-right-xs" v-if="users>1" @click="toChiose">角色选择</div>-->
<!--                <div class="to" v-if="user" @click="sginout">退出</div>-->
                <!--                <el-link class="to-emof" :href="user.morgurl ? user.morgurl : web_zc_home" :underline="false" target="_blank">-->
                <!--                    <div class="title">{{user.morgurl ? '访问首页' : '访问益魔方首页'}}</div>-->
                <!--                    <div class="tips" v-if="!user.morgurl">免费获取更多实用工具</div>-->
                <!--                </el-link> -->
<!--                <el-link class="to-emof" :href="IMAGE_PATH" :underline="false" target="_blank">-->
<!--                    <div class="title">访问首页</div>-->
<!--                </el-link>-->
            </div>
        </div>
    </div>
</template>

<script>
import {service_phone, web_emof_home, web_emof_news, web_emof_setting, web_zc_home} from "@/utils/const";
import {IMAGE_PATH} from "@/config";

export default {
    components: {},
    name: "headers",
    data() {
        return {
            IMAGE_PATH: IMAGE_PATH,
            web_emof_home: '',
            web_emof_setting: '',
            web_emof_news: web_emof_news,
            web_zc_home: web_zc_home,
            service_phone: service_phone
        }
    },
    props: {},
    computed: {
        user() {
            return this.$store.state.user
        },
        users() {
            return this.$store.state.userAll ? this.$store.state.userAll.length : 0
        }
    },
    created() {
        this.web_emof_home = web_emof_home + 'tiaoz.html?code=' + this.user.emofUserTokenSafer + '&path=/home'
        this.web_emof_setting = web_emof_setting + 'tiaoz.html?code=' + this.user.emofUserTokenSafer + '&path=/st/setup'
    },
    methods: {
        toChiose() {
            this.$router.replace('/choice')
        },
        async init() {
        },
        sginout() {
            this.$confirm(
                '您确定要退出吗？',
                '温馨提示', {
                    confirmButtonText: '确定',
                    type: 'warning',
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                }
            ).then(() => {
                this.$store.dispatch('LogOut').then(() => {
                    this.$router.replace('/login')
                    window.localStorage.clear()
                    // location.reload() // 为了重新实例化vue-router对象 避免bug
                })
            })
        }
    }
}
</script>

<style scoped lang="scss">
.header-container {
    background-color: #0a2240;
    box-shadow: 0px 6px 18px 1px rgba(10, 34, 64, 0.45);
    width: 100%;

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 1200px;
        height: 100px;
        margin: 0 auto;

        .logo {
            margin: 20px 0;
            height: 42px;
        }
        .logo_zc {
            margin: 20px 0;
            height: 52px;
        }

        .home {
            .service {
                font-size: 16px;
                color: #f5f5f5;
                margin-right: 20px;
            }

            .operate {
                padding: 0 26px;
                height: 40px;
                background-color: #ff9600;
                border-radius: 20px;
                font-size: 16px;
                color: #ffffff;
                line-height: 40px;
                text-align: center;
                cursor: pointer;
                user-select: none;
            }

            .to {
                width: 99px;
                height: 40px;
                border-radius: 20px;
                border: solid 1px #ffffff;
                font-size: 16px;
                line-height: 40px;
                text-align: center;
                color: #ffffff;
                margin-right: 10px;
                cursor: pointer;
            }

            .to-emof {
                width: 150px;
                height: 41px;
                background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                linear-gradient(#ff9600, #ff9600);
                background-blend-mode: normal, normal;
                border-radius: 20px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                .title {
                    font-size: 14px;
                    font-weight: bold;
                    color: #ffffff;
                    text-align: center;
                }

                .tips {
                    font-size: 12px;
                    color: #021e3f;
                }
            }
        }
    }
}
</style>
